import {
  RESEARCH_MODE_THREADS_ENDPOINT,
  RESEARCH_MODE_THREAD_ENDPOINT,
} from 'api/constants';
import { api } from 'store/api/api';

import type {
  ResearchThread,
  ResearchThreadsList,
} from './research-threads.api.types';

const researchThreadsApi = api
  .enhanceEndpoints({
    addTagTypes: ['ResearchModeThreads', 'ResearchModeThread'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getResearchThreads: builder.query<ResearchThreadsList, void>({
        query: () => ({
          url: RESEARCH_MODE_THREADS_ENDPOINT,
          method: 'GET',
          credentials: 'include',
        }),
        providesTags: ['ResearchModeThreads'],
        keepUnusedDataFor: 60,
      }),
      getResearchThread: builder.query<ResearchThread, { threadId: string }>({
        query: ({ threadId }) => ({
          url: RESEARCH_MODE_THREAD_ENDPOINT.replace(':threadId', threadId),
          method: 'GET',
          credentials: 'include',
        }),
        providesTags: (_, __, { threadId }) => [
          { type: 'ResearchModeThread', id: threadId },
        ],
        keepUnusedDataFor: 60,
      }),
      deleteResearchThread: builder.mutation<void, { threadId: string }>({
        query: ({ threadId }) => ({
          url: RESEARCH_MODE_THREAD_ENDPOINT.replace(':threadId', threadId),
          method: 'DELETE',
          credentials: 'include',
        }),
        invalidatesTags: (_, __, { threadId }) => [
          { type: 'ResearchModeThread', id: threadId },
          'ResearchModeThreads',
        ],
      }),
    }),
  });

export const {
  useGetResearchThreadsQuery,
  useLazyGetResearchThreadQuery,
  useDeleteResearchThreadMutation,
} = researchThreadsApi;
